import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { fetchCombinedDataViews, fetchChildCompanyCombinedDataViews, fetchDataViewHash } from '../../actions/CombinedDataViewActions'
import SiteContainer from '../../components/layout/SiteContainer'
import ContainerHeading from '../../components/layout/ContainerHeading'
import HelmetTitle from '../../components/layout/HelmetTitle'
import LoadingScreen from '../../components/LoadingScreen'
import Graph from '../../components/dataViews/Graph'
import DataTable from '../../components/dataViews/DataTable'
import { GridContainer, GridSection, Column, ListHeaderRow, ListRow, ColumnStyle, SmallScreenSiteDataColumnStyle, SmallScreenSiteDataSiteName, SmallScreenSiteDataDetail, ActionHeaderColumnStyle, ActionColumnStyle, ActionColumnStyleRightAligned, ActionIconContainer } from './styled-elements'
import styledTheme from '../../styles/theme'
import ArrowRightBoldCircle from '../../components/icons/ArrowRightBoldCircle'
import Moment from 'moment-timezone'

class CombinedDataViews extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      layoutWidth: this.getLayoutWdth()
    }
  }

  getLayoutWdth = () => {
    if (typeof window === 'undefined') return styledTheme.breakpoints.lg
    return window.innerWidth
  }

  resizeHandler = (e) => {
    if (e.target.innerWidth===this.state.layoutWidth) return
    this.setState({ layoutWidth: this.getLayoutWdth() })
  }

  componentDidMount() {
    const { apiAuth, dispatch } = this.props
    const { user } = apiAuth
    if (user.company_type==='user') {
      dispatch(fetchCombinedDataViews(user.company_slug))
    } else if (['dealer','consultant'].indexOf(user.company_type) > -1) {
      dispatch(fetchChildCompanyCombinedDataViews(user.company_slug))
    }
    this.checkForDataViewSlugAndLoadhash()
    window.addEventListener('resize', this.resizeHandler)
  }

  componentDidUpdate(prevProps) {
    this.checkForDataViewSlugAndLoadhash(prevProps)
  }

  checkForDataViewSlugAndLoadhash = ( prevProps={ match: { params: {} }} ) => {
    const { apiAuth, dispatch, match } = this.props
    const { user } = apiAuth
    const companySlug = match.params.company_slug
    const dataViewSlug = match.params.data_view_slug

    if (dataViewSlug===prevProps.match.params.data_view_slug) return null

    if (user.company_type==='user') {
      dispatch(fetchCombinedDataViews(user.company_slug))
    } else if (['dealer','consultant'].indexOf(user.company_type) > -1) {
      dispatch(fetchChildCompanyCombinedDataViews(user.company_slug))
    }
    if (dataViewSlug) dispatch(fetchDataViewHash(companySlug,dataViewSlug))

  }

  formatTime(timeInt,timezone) {
    const currentTimeInt = parseInt(new Date().getTime()/1000,10)
    const diffSecs = currentTimeInt-timeInt/1000
    if (diffSecs < 60) {
      return `${diffSecs} seconds ago`
    } else if (diffSecs < 3600) {
      return `${parseInt(diffSecs/60,10)} minutes ago`
    } else if (diffSecs < 7200) {
      return `1 hour ago`
    } else if (diffSecs < 86400) {
      return `${parseInt(diffSecs/3600,10)} hours ago`
    } else if (diffSecs < 172800) {
      return `1 day ago`
    } else if (diffSecs < 8640000) {
      return `${parseInt(diffSecs/86400,10)} days ago`
    } else {
      return Moment(timeInt*1000).format('DD MMM YYYY HH:mm')
    }
  }

  routeToDataViews = (combinedDataView) => {
    this.props.dispatch(push(`/combined_data_views/${combinedDataView.company_slug}/${combinedDataView.slug}`))
  }

  isMobileView = () => {
    const screenWidth = window.innerWidth
    return (screenWidth < styledTheme.breakpoints.md)
  }

  renderCombinedDataViewsHeaderRow = (parentCompanyView) => <ListHeaderRow key={0}>
    { parentCompanyView && <Column xs={3} style={ColumnStyle}>Company Name</Column> }
    <Column xs={parentCompanyView ? 4 : 5} style={ColumnStyle}>Site Name</Column>
    <Column xs={parentCompanyView ? 2 : 3} style={ColumnStyle}>Data Last Updated</Column>
    <Column xs={1} style={ActionHeaderColumnStyle}>View</Column>
  </ListHeaderRow>

  renderSmallScreenSiteRows = (combinedDataViews,parentCompanyView) => combinedDataViews.map((combinedDataView,index) => <ListRow key={index+1} onClick={this.routeToDataViews.bind(this,combinedDataView)}>
    <Column xs={10} style={SmallScreenSiteDataColumnStyle}>
        <SmallScreenSiteDataSiteName>{combinedDataView.name}</SmallScreenSiteDataSiteName>
        { parentCompanyView && <SmallScreenSiteDataDetail>{combinedDataView.company_name }</SmallScreenSiteDataDetail> }
        <SmallScreenSiteDataDetail>{combinedDataView.last_updated_at ? `Last updated ${this.formatTime(combinedDataView.last_updated_at, combinedDataView.timezone_name)}` : 'No data retrieved yet'}</SmallScreenSiteDataDetail>
    </Column>
    <Column xs={2} style={ActionColumnStyleRightAligned}><ActionIconContainer onClick={this.routeToDataViews.bind(this,combinedDataView)}><ArrowRightBoldCircle /></ActionIconContainer></Column>
  </ListRow>)

  renderLargeScreenSiteRows = (combinedDataViews,parentCompanyView) => combinedDataViews.map((combinedDataView,index) => <ListRow key={index+1} onClick={this.routeToDataViews.bind(this,combinedDataView)}>
    { parentCompanyView && <Column xs={3} style={ColumnStyle}>{combinedDataView.company_name}</Column> }
    <Column xs={parentCompanyView ? 4 : 5} style={ColumnStyle}>{combinedDataView.name}</Column>
    <Column xs={parentCompanyView ? 2 : 3} style={ColumnStyle}>{combinedDataView.last_updated_at ? this.formatTime(combinedDataView.last_updated_at, combinedDataView.timezone_name) : ''}</Column>
    <Column xs={1} style={ActionColumnStyle}><ActionIconContainer onClick={this.routeToDataViews.bind(this,combinedDataView)}><ArrowRightBoldCircle /></ActionIconContainer></Column>
  </ListRow>)

  renderCombinedDataViews(combinedDataViews,companyType) {
    const parentCompanyView = (['dealer','consultant'].indexOf(companyType) > -1)
    const isMobileView = this.isMobileView()
    if (combinedDataViews.dataViews) {
      return <GridContainer>
        <ContainerHeading title={`Combined Data Views`} />
        <GridSection>
          { isMobileView && this.renderSmallScreenSiteRows(combinedDataViews.dataViews,parentCompanyView) }
          { !isMobileView && this.renderCombinedDataViewsHeaderRow(parentCompanyView) }
          { !isMobileView && this.renderLargeScreenSiteRows(combinedDataViews.dataViews,parentCompanyView) }
        </GridSection>
      </GridContainer>
    }
  }

  dataViewCloseDataViewHandler = () => {
    this.props.history.replace(`/combined_data_views`)
  }

  renderShowDataView(props,state) {
    const { dispatch, combinedDataViews } = props
    const { dataViews, dataViewHash } = combinedDataViews
    const dataViewSlug = props.match.params.data_view_slug
    const dataView = dataViews.find(dv => dv.slug===dataViewSlug)
    if (dataView) {
      switch (dataView.data_view_type_category) {
        case 'graph':
          if (combinedDataViews.dataViewHash && combinedDataViews.dataViewHash.chart) {
            const options = dataViewHash
            return <Graph
              closeDataViewHandler={this.dataViewCloseDataViewHandler}
              dispatch={dispatch}
              dataView={dataView}
              options={options}
              dataViewSummary={props.dataViews}
              manualInputFormOpenHandler={this.manualInputFormOpenHandler}
              manualInputFormCloseHandler={this.manualInputFormCloseHandler}
              ref={this.graphComponent}
            />
          }
          break
        case 'table':
          // if (dataView.data_view_type_key==="table_retrieve_data_events") return <DataRetrievalsTable closeDataViewHandler={this.dataViewCloseDataViewHandler} dispatch={dispatch} site={site} dataView={dataView} data={props.dataViews.dataViewHash} downloadAsClickHandler={this.downloadAsClickHandler} />
          // if (dataView.data_view_type_key==="table_all_sensors") return <DataTable closeDataViewHandler={this.dataViewCloseDataViewHandler} dispatch={dispatch} site={site} dataView={dataView} data={props.dataViews.dataViewHash} downloadAsClickHandler={this.downloadAsClickHandler} />
          break
        default:
          return null
      }
    }
  }

  getLoadingScreenState() {
    const { apiAuth, combinedDataViews } = this.props
    return (
      apiAuth.validating ||
      (!combinedDataViews.dataViews.length && combinedDataViews.fetching) ||
      (!Object.keys(combinedDataViews.dataViewHash || {}).length && combinedDataViews.fetching)
    )
  }

  renderBody = (props,state) => <div>
    <LoadingScreen show={this.getLoadingScreenState()}/>
    { props.combinedDataViews && props.apiAuth.user && this.renderCombinedDataViews(props.combinedDataViews,props.apiAuth.user.company_type) }
    { props.match.params.data_view_slug && props.combinedDataViews && this.renderShowDataView(props,state) }
  </div>

  render = () => <SiteContainer isSignedIn={this.props.apiAuth.isSignedIn}>
    <HelmetTitle title={`Combined Data Views`} />
    {this.renderBody(this.props,this.state)}
  </SiteContainer>

}

export default connect(
  (store, props) => ({
    apiAuth: store.apiAuth,
    combinedDataViews: store.combinedDataViews,
    routing: store.routing,
  }),
)(CombinedDataViews)



// WEBPACK FOOTER //
// ./src/containers/combinedDataViews/index.js